export function changeColorInCSSObject(classes, color) {
  Object.keys(classes).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(classes[key], 'fill')) {
      // eslint-disable-next-line no-param-reassign
      classes[key].fill = color
    }
  })
}
